import useIsomorphicLayoutEffect from '@/core/hooks/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

export default useIsomorphicLayoutEffect;
